<template>
  <div id="denied" :class='{ mobile: isMobile() }' class="fade-in">
    <div class="denied-content">
      <StepInfoHeader :showHeaderHelperIcon="false"/>

      <div class="denied-content--image">
        <asset-v3
          class="phone-icon"
          dir="abstract"
          name="sad-bag.svg"
        />
      </div>

      <div class="denied-content--main">
        <h3>Crédito não disponível no momento</h3>
        <p> Ainda não temos crédito disponível para o seu perfil.</p>
        <p>Para uma nova análise de crédito, aguarde 60 dias e tente novamente em nosso site.</p>
        <a href="https://ajuda.parcelex.com.br/credito-indisponivel" target="_blank">Entenda o porquê</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import UtilMixing from '@/mixins/util';
import AssetV3 from '@/components/common/AssetV3.vue';
import StepInfoHeader from '../components/StepInfoHeader.vue';

export default {
  name: 'onboarding-denied',
  mixins: [UtilMixing],
  components: { StepInfoHeader, AssetV3 },
  computed: {
    ...mapState('auth', ['token']),
  },
  methods: {
    goToMeuParcelex() {
      this.$router.push(`/portal?authToken=${this.token}`);
    },
  },
};
</script>

<style lang="scss" scoped>
  // font-family: 'Usual';
  @import url("https://use.typekit.net/vtp2byb.css");

  // font-family: 'Arboria';
  @import url("https://use.typekit.net/ioq1obq.css");

  #denied {
    padding-top: 20px;
    background-color: var(--gray-100);
    box-sizing: inherit;
    position: relative;
    min-height: 100vh;
    max-width: 100%;
    margin: 0 auto;

    .denied-content {
      padding: 0 24px;
      min-width: $sm;
      max-width: 642px;
      min-height: 304px;
      background-color: var(--white);
      border-radius: 4px;
      border: 1px solid var(--gray-300);
      box-sizing: border-box;
      margin: 0 auto;
    }

    .denied-content--main {
      h3, p {
        margin-bottom: 20px;
      }

      h3 {
        font-family: 'Arboria';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 32px;
        color: var(--gray-900);
      }

      p, a {
        font-family: 'Usual';
        font-weight: 400;
        font-style: normal;
        font-size: 18px;
        line-height: 28px;

        @media (min-width: $breakpoint-large) {
          font-size: 16px;
          line-height: 24px;
        }
      }
    }

    .denied-content--image {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      margin: 36px 0 12px;
    }

    &.mobile {
      padding: 0px;
      background-color: var(--white);

      .denied-content {
        margin: 0 auto;
        min-width: 100%;
        border: 0px;

        h3, p {
          text-align: left;
        }
      }
    }
  }

</style>
